module.exports = __webpack_public_path__ + "static/media/NumberTwo.a03649ec.svg";